/*
 * @Description: 在线客服
 */
import React, { useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from 'react';
import { Flex } from 'antd-mobile';
import { routeAuthCodeMap } from 'utils/constants';
import { isHasRouteAuth } from 'utils/authUtil';
import { observer, useObserver } from 'mobx-react';
import PropTypes from 'prop-types';
import Util from 'utils';
import Config from 'config/Config';
import styles from './index.modules.less';

const CDN_BASE = Config.CDN_BASE || '';

// 相当于inject('AppMod');
// 需要将使用的数据用useObserver包起来 不然会监听不到数据变化
const useAppModData = () => {
  const { userInfo, onLineServiceUrl } = Util.useStores('AppMod');
  return useObserver(() => ({
    userInfo,
    onLineServiceUrl
  }));
};

// 初始化在线客服sdk
const initializeOnlineService = (onLineServiceUrl, ...arg) => {
  (function (w, d, n, a, j) {
    w[n] =
      w[n] ||
      function (...restArg) {
        (w[n].a = w[n].a || []).push(restArg);
      };
    j = d.createElement('script');
    j.async = true;
    j.src = onLineServiceUrl;
    d.body.appendChild(j);
  })(window, document, 'ysf', ...arg);
};

// px转换rem
const transformRem = (value) => {
  if (!value) return 0;
  if (value.indexOf('rem') > -1) {
    return value;
  }
  if (value.indexOf('px') >= -1) {
    return `${value.split('px')[0] / 100}rem`;
  }
};

const ServiceView = observer(
  forwardRef((props, ref) => {
    const { userInfo, onLineServiceUrl } = useAppModData();
    const ServiceRef = useRef(null);

    useEffect(() => {
      // 确保SDK只初始化一次
      initializeOnlineService(onLineServiceUrl);
    }, [onLineServiceUrl]);

    // 上报事件
    const handleOnlineServiceClick = useCallback((userInfo) => {
      window.ysf('config', {
        uid: userInfo ? userInfo.id : '',
        success() {
          console.log('客户信息上报成功');
          window.ysf('onready', function () {
            window.ysf('open');
          });
        },
        error() {
          console.log('客户信息上报失败');
        }
      });
    }, []);

    useImperativeHandle(ref, () => ({
      ServiceRef,
      handleOnlineServiceClick
    }));

    if (!isHasRouteAuth(routeAuthCodeMap.ONLINE_SERVICE)) return null;
    return (
      <Flex
        ref={ServiceRef}
        justify="between"
        className={styles['linchen-service-support']}
        style={{
          '--bottom': transformRem(props.bottom),
          '--right': transformRem(props.right)
        }}
        onClick={() => {
          if (props.onClick) {
            props.onClick(userInfo, onLineServiceUrl);
          } else {
            handleOnlineServiceClick(userInfo, onLineServiceUrl);
          }
        }}>
        {/* <span className = 'iconfont kefu' /> */}
        <img
          className={styles.kefu}
          src={`${CDN_BASE}/assets/imgs/shop/online_customer_service.png`}
        />
      </Flex>
    );
  })
);

ServiceView.defaultProps = {
  bottom: 0,
  right: 0,
  onClick: null
};

ServiceView.propTypes = {
  bottom: PropTypes.string.isRequired, // 必填 底部距离 支持px/rem
  right: PropTypes.string.isRequired, // 必填 右侧边距离 支持px/rem
  onClick: PropTypes.func // 选填 点击事件，点击事件会抛出跳转所需要的userInfo和onLineServiceUrl，并且通过ref外抛了handleOnlineServiceClick方法 默认值 null
};

export default ServiceView;



// WEBPACK FOOTER //
// ./src/pubBiz/Service/index.js